import { HttpClient, HttpParams, type HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { ChangePasswordDTO, CreateSystemAdminDTO, IPaginationParams } from '@interfaces';
import { ApiResponse } from '@shared';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SystemAdminService {
  constructor(private readonly http: HttpClient) {}
  private adminListCountSubject = new BehaviorSubject<number>(0);
  public $adminCount = this.adminListCountSubject.asObservable();
  getAllTypes(params: IPaginationParams): Observable<ApiResponse> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.append(key, String((params as any)[key]));
      });
    }
    params?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      httpParams = httpParams.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/system-admin/admin-type', { params: httpParams });
  }

  getAdminTypeDetail(id: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`/v1/admin/system-admin/admin-type/${id}`);
  }

  deleteAdminType(id: string): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`/v1/admin/system-admin/admin-type/${id}`);
  }

  createAdminType(adminType: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`/v1/admin/system-admin/admin-type`, adminType);
  }

  updateAdminType(id: string, adminType: any): Observable<ApiResponse> {
    return this.http.patch<ApiResponse>(`/v1/admin/system-admin/admin-type/${id}`, adminType);
  }

  createAdmin(adminType: CreateSystemAdminDTO): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`/v1/admin/system-admin`, adminType);
  }

  updateAdmin(id: string, adminType: CreateSystemAdminDTO): Observable<ApiResponse> {
    return this.http.patch<ApiResponse>(`/v1/admin/system-admin/${id}`, adminType);
  }

  getAllAdmin(params: IPaginationParams): Observable<ApiResponse> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.append(key, String((params as any)[key]));
      });
    }
    params?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      httpParams = httpParams.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/system-admin', { params: httpParams });
  }

  getAdminDetail(id: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`/v1/admin/system-admin/${id}`);
  }

  deleteAdmin(id: string): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`/v1/admin/system-admin/${id}`);
  }

  changePassword(id: string, payload: ChangePasswordDTO): Observable<ApiResponse> {
    return this.http.patch<ApiResponse>(`/v1/admin/system-admin/change-password/${id}`, payload);
  }
  exportAdminList(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(`/v1/admin/system-admin/export`, filterData, options);
  }
  exportAdminTypes(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(`/v1/admin/system-admin/exportType`, filterData, options);
  }

  getAdminCount() {
    return this.http.get<ApiResponse>(`/v1/admin/system-admin/admin-count`);
  }

  getCurrentAdmin() {
    return this.http.get<ApiResponse>(`/v1/admin/system-admin/current-admin`);
  }
  setAdminCount(count: number) {
    this.adminListCountSubject.next(count);
  }
}
